@if (!processing()) {
    <nz-layout [class.admin-page]="isAdminPage()" [class]="appHasAuth ? 'apollo-app' : 'connect-app'">
        <nz-header>
            @if (initializeRoutes()) {
                <adspt-header
                    class="a-fx-between-center a-fx a-fx-fill"
                    [hideLinks]="isOauthApp || isSignupApp"
                    [disableLinks]="disableLinks()"
                />
            }
        </nz-header>
        @if (appHasAuth) {
            <adspt-global-side-nav [disableLinks]="disableLinks()" />
        }

        <nz-content [ngClass]="layoutClass()">
            @if (impersonationId()) {
                <adspt-impersonation-banner />
            }
            @if (hasErrors()) {
                <nz-alert nzType="error" nzMessage="Ooops!" [nzDescription]="errTemplate()" nzShowIcon />
            }
            @if (showRouterOutlet()) {
                @if (!isSignupApp) {
                    <adspt-account-move-banner />
                    <adspt-subscription-alert />
                    <adspt-email-verification />
                    <adspt-disallowed-optimization-banner />
                }
                <router-outlet />
            }
        </nz-content>
    </nz-layout>
}

<ng-template #errGeneric>
    <p>
        <span [innerHTML]="'common.error-msg' | translate"></span>&nbsp;<span
            [innerHTML]="'common.contact-service' | translate"
        ></span>
    </p>
</ng-template>

<ng-template #errInValidUser>
    <p [innerHTML]="'common.errors.notValidUser' | translate"></p>
</ng-template>

@if (toast$ | async; as toast) {
    @if (toast.show) {
        <adspt-toaster
            [type]="toast.type"
            [title]="toast.title | translate"
            [duration]="toast.duration"
            [action]="toast.action"
            [actionTxt]="toast.actionTxt"
            (closed)="hideToast()"
        />
    }
}
